const SCHOOL_KEY = 'homeworkSchool';
const BOARD_KEY = 'homeworkBoard';
const SELECTIONS_KEY = 'homeworkSubjectGroups';

const selectionStorageKey = (boardId = getStoredBoard()) =>
  boardId ? `${SELECTIONS_KEY}:${boardId}` : SELECTIONS_KEY;

export function getStoredSchool() {
  return localStorage.getItem(SCHOOL_KEY) || '';
}

export function setStoredSchool(uid) {
  if (uid) localStorage.setItem(SCHOOL_KEY, uid);
}

export function getStoredBoard() {
  return localStorage.getItem(BOARD_KEY) || '';
}

export function setStoredBoard(boardId) {
  if (boardId) {
    localStorage.setItem(BOARD_KEY, boardId);
  } else {
    localStorage.removeItem(BOARD_KEY);
  }
}

export function clearStoredSchool() {
  localStorage.removeItem(SCHOOL_KEY);
  localStorage.removeItem(BOARD_KEY);
  for (let index = localStorage.length - 1; index >= 0; index -= 1) {
    const key = localStorage.key(index);
    if (key === SELECTIONS_KEY || key?.startsWith(`${SELECTIONS_KEY}:`)) {
      localStorage.removeItem(key);
    }
  }
}

export function getSubjectSelections(boardId = getStoredBoard()) {
  try {
    const key = selectionStorageKey(boardId);
    const storedValue = localStorage.getItem(key)
      ?? (boardId ? localStorage.getItem(SELECTIONS_KEY) : null)
      ?? '{}';
    const value = JSON.parse(storedValue);
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  } catch (error) {
    console.warn('Unable to read saved subject groups:', error);
    return {};
  }
}

export function replaceSubjectSelections(selections, boardId = getStoredBoard()) {
  localStorage.setItem(selectionStorageKey(boardId), JSON.stringify(selections || {}));
  return selections || {};
}

export function saveSubjectSelection(subject, group, boardId = getStoredBoard()) {
  const selections = getSubjectSelections(boardId);
  if (group?.public_token) {
    selections[subject] = {
      tag_id: group.tag_id,
      tag_name: group.tag_name,
      public_token: group.public_token,
    };
  } else {
    delete selections[subject];
  }
  return replaceSubjectSelections(selections, boardId);
}

export function selectedGroupTokens(selections = getSubjectSelections()) {
  return [...new Set(Object.values(selections)
    .map((group) => group?.public_token)
    .filter(Boolean))];
}

export function uniqueSubjectCatalog(subjectRows = []) {
  const catalog = [];
  const subjectsByKey = new Map();

  subjectRows.forEach((item) => {
    const subject = String(typeof item === 'string' ? item : item?.subject || '').trim();
    const key = subject.toLocaleLowerCase();
    if (!subject) return;

    let catalogItem = subjectsByKey.get(key);
    if (!catalogItem) {
      catalogItem = { subject, class_tags: [] };
      subjectsByKey.set(key, catalogItem);
      catalog.push(catalogItem);
    }

    const includedTags = new Set(catalogItem.class_tags.map((tag) => tag.tag_id || tag.public_token));
    (typeof item === 'object' ? item.class_tags || [] : []).forEach((tag) => {
      const tagKey = tag.tag_id || tag.public_token;
      if (!tagKey || includedTags.has(tagKey)) return;
      includedTags.add(tagKey);
      catalogItem.class_tags.push(tag);
    });
  });

  return catalog;
}
